// src/app/slices/hoodSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccessoryState, IHood, IHoodParams } from '../models';
import { deleteAccessory } from './actions';

const initialState: AccessoryState<IHood, IHoodParams> = {
  accessories: {},
  params: null,
};

const hoodSlice = createSlice({
  name: 'hood',
  initialState,
  reducers: {
    setHood: (state, action: PayloadAction<IHood>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setHoodParams: (state, action: PayloadAction<IHoodParams>) => {
      state.params = action.payload;
    },
    deleteHood: deleteAccessory,
  },
});

export const { setHood, setHoodParams, deleteHood } = hoodSlice.actions;

export default hoodSlice.reducer;
